
<div class="manuscriptEditor quillWrapper">
    <div
        ref="quillContainer"
        :class="{ 'ql-container': true }"
        :style="manuscriptStyle"
        spellcheck="false"
    ></div>
</div>
